import { useCallback } from 'react';
import { getPageEventContext } from '|/app/purchase/checkout/constants/page-event-mappings';
import { VERIFICATION_STEP_IDS } from '|/app/purchase/checkout/verifications/constants';
import { Step, StepName } from '|/app/services';
import useEventHelper from '|/hooks/use-event-helper';

const shownSteps = new Set<StepName>();

export function _resetForTesting() {
  shownSteps.clear();
}

const useControlShowEvents = () => {
  const { sendShowEvent } = useEventHelper();

  return useCallback(
    (steps: Step[], isInTreatment: boolean) => {
      if (isInTreatment) return;
      if (!steps || steps.length === 0) return;

      for (const step of steps) {
        if (step.section !== 2) continue;
        if (!step.isEnabled) continue;
        if (!VERIFICATION_STEP_IDS.has(step.id)) continue;
        if (step.id === StepName.PlaceOrder) continue;
        if (shownSteps.has(step.id)) continue;

        shownSteps.add(step.id);
        const context = getPageEventContext(step.id);
        if (context) {
          sendShowEvent(context);
        }
      }
    },
    [sendShowEvent]
  );
};

export default useControlShowEvents;
